// Product Card Variant Selector

// Custom AJAX add to cart with visual feedback
function setupFormSubmit(form, button) {
  if (!form || !button) return;
  
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    
    const originalText = button.textContent;
    
    // Lock button size to prevent layout shift
    button.style.minWidth = button.offsetWidth + 'px';
    button.style.minHeight = button.offsetHeight + 'px';
    
    // Show loading state with animated dots
    button.innerHTML = '<span class="loading-dots"><span>.</span><span>.</span><span>.</span></span>';
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    
    const formData = new FormData(form);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Show success
      button.textContent = '✓';
      
      // Refresh cart (updates count and drawer content)
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      
      // Reset button after delay
      setTimeout(function() {
        button.textContent = originalText;
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }, 1500);
    })
    .catch(error => {
      // Show error
      button.textContent = 'שגיאה';
      setTimeout(function() {
        button.textContent = originalText;
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }, 1500);
    });
  });
}

// Track which cards have been initialized
const initializedCards = new WeakSet();

function initProductCards() {
  const cards = document.querySelectorAll('product-card');
  
  cards.forEach(function(card) {
    // Skip already initialized cards
    if (initializedCards.has(card)) {
      return;
    }
    initializedCards.add(card);
    
    const form = card.querySelector('.product-card__form');
    if (!form) return;
    
    const variantInput = form.querySelector('.product-card__variant-id');
    const variantsJson = card.querySelector('.product-card__variants-json');
    const button = form.querySelector('.product-card__add-button');
    
    // Setup custom form submit with visual feedback
    setupFormSubmit(form, button);
    
    // For single-variant products (no variantsJson), we're done
    if (!variantsJson) return;
    
    // Multi-variant product handling below
    const variants = JSON.parse(variantsJson.textContent);
    const swatches = card.querySelectorAll('.product-card__swatch');
    const selects = card.querySelectorAll('.product-card__select');
    const primaryImage = card.querySelector('.product-card__image--primary');
    const colorSwatchGroups = card.querySelectorAll('.product-card__color-swatches');
    const totalOptionGroups = colorSwatchGroups.length + selects.length;
    
    function getSelectedOptions() {
      const options = {};
      let selectedCount = 0;
      
      // Get color swatch selections
      colorSwatchGroups.forEach(function(container) {
        const index = container.dataset.optionIndex;
        const selected = container.querySelector('.is-selected');
        if (selected) {
          options['option' + index] = selected.dataset.optionValue;
          selectedCount++;
        }
      });
      
      // Get dropdown selections
      selects.forEach(function(select) {
        const index = select.dataset.optionIndex;
        if (select.value) {
          options['option' + index] = select.value;
          selectedCount++;
        }
      });
      
      return { options, selectedCount };
    }
    
    function findVariant(options) {
      return variants.find(function(variant) {
        for (let key in options) {
          if (variant[key] !== options[key]) return false;
        }
        return true;
      });
    }
    
    function updateImage(variant) {
      if (!variant || !variant.featured_image) return;
      
      const newSrc = variant.featured_image.src;
      if (!newSrc) return;
      
      // Update primary image
      if (primaryImage) {
        const newSrcset = newSrc.replace(/&width=\d+/, '') + '&width=200 200w, ' +
                          newSrc.replace(/&width=\d+/, '') + '&width=300 300w, ' +
                          newSrc.replace(/&width=\d+/, '') + '&width=400 400w, ' +
                          newSrc.replace(/&width=\d+/, '') + '&width=500 500w, ' +
                          newSrc.replace(/&width=\d+/, '') + '&width=600 600w';
        primaryImage.src = newSrc.replace(/&width=\d+/, '&width=600');
        primaryImage.srcset = newSrcset;
      }
    }
    
    function formatMoney(cents) {
      const price = (cents / 100).toFixed(2);
      return price + ' ₪';
    }
    
    function updatePrice(variant) {
      const priceList = card.querySelector('price-list');
      if (!priceList || !variant) return;
      
      const salePrice = priceList.querySelector('sale-price');
      const comparePrice = priceList.querySelector('compare-at-price');
      
      if (salePrice) {
        // Keep the sr-only span, update the visible price
        const srOnly = salePrice.querySelector('.sr-only');
        const srText = srOnly ? srOnly.outerHTML : '';
        salePrice.innerHTML = srText + formatMoney(variant.price);
      }
      
      // Handle compare at price
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (comparePrice) {
          const srOnly = comparePrice.querySelector('.sr-only');
          const srText = srOnly ? srOnly.outerHTML : '';
          comparePrice.innerHTML = srText + formatMoney(variant.compare_at_price);
          comparePrice.style.display = '';
        }
      } else if (comparePrice) {
        comparePrice.style.display = 'none';
      }
    }
    
    function updateVariant() {
      const { options, selectedCount } = getSelectedOptions();
      
      // Check if all options are selected
      if (selectedCount < totalOptionGroups) {
        variantInput.value = '';
        if (button) {
          button.disabled = true;
          button.classList.add('is-disabled');
          button.classList.remove('is-unavailable');
        }
        return;
      }
      
      const variant = findVariant(options);
      
      if (variant) {
        variantInput.value = variant.id;
        updateImage(variant);
        updatePrice(variant);
        
        // Update SKU display if exists
        const skuEl = card.querySelector('.product-card__sku');
        if (skuEl && variant.sku) {
          skuEl.textContent = variant.sku;
        }
        
        // Update button state based on availability
        if (button) {
          button.disabled = !variant.available;
          button.classList.remove('is-disabled');
          button.classList.toggle('is-unavailable', !variant.available);
        }
      } else {
        variantInput.value = '';
        if (button) {
          button.disabled = true;
          button.classList.add('is-unavailable');
        }
      }
    }
    
    // Swatch click handler
    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        const container = this.closest('.product-card__color-swatches');
        container.querySelectorAll('.product-card__swatch').forEach(function(s) {
          s.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        updateVariant();
      });
    });
    
    // Select change handler
    selects.forEach(function(select) {
      select.addEventListener('change', updateVariant);
    });
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', initProductCards);

// Re-initialize after Ajaxinate loads more products
document.addEventListener('ajaxinate:loaded', initProductCards);

// Also watch for DOM changes (backup for any dynamic loading)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      
      // Check if the node itself is a product card
      if (node.tagName === 'PRODUCT-CARD' && !initializedCards.has(node)) {
        initSingleProductCard(node);
      }
      
      // Check for product cards inside the added node
      if (node.querySelectorAll) {
        node.querySelectorAll('product-card').forEach(function(card) {
          if (!initializedCards.has(card)) {
            initSingleProductCard(card);
          }
        });
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

function initSingleProductCard(card) {
  // Mark as initialized
  initializedCards.add(card);
  
  const form = card.querySelector('.product-card__form');
  if (!form) return;
  
  const variantInput = form.querySelector('.product-card__variant-id');
  const variantsJson = card.querySelector('.product-card__variants-json');
  const button = form.querySelector('.product-card__add-button');
  const primaryImage = card.querySelector('.product-card__image--primary');
  
  // Setup form submit
  setupFormSubmit(form, button);
  
  if (!variantsJson) return;
  
  const variants = JSON.parse(variantsJson.textContent);
  const swatches = card.querySelectorAll('.product-card__swatch');
  const selects = card.querySelectorAll('.product-card__select');
  const colorSwatchGroups = card.querySelectorAll('.product-card__color-swatches');
  const totalOptionGroups = colorSwatchGroups.length + selects.length;
  
  function getSelectedOptions() {
    const options = {};
    let selectedCount = 0;
    
    colorSwatchGroups.forEach(function(container) {
      const index = container.dataset.optionIndex;
      const selected = container.querySelector('.is-selected');
      if (selected) {
        options['option' + index] = selected.dataset.optionValue;
        selectedCount++;
      }
    });
    
    selects.forEach(function(select) {
      const index = select.dataset.optionIndex;
      if (select.value) {
        options['option' + index] = select.value;
        selectedCount++;
      }
    });
    
    return { options, selectedCount };
  }
  
  function findVariant(options) {
    return variants.find(function(variant) {
      let match = true;
      for (let key in options) {
        if (variant[key] !== options[key]) {
          match = false;
          break;
        }
      }
      return match;
    });
  }
  
  function updateImage(variant) {
    if (!variant || !variant.featured_image) return;
    
    const newSrc = variant.featured_image.src;
    if (!newSrc) return;
    
    // Update primary image
    if (primaryImage) {
      const newSrcset = newSrc.replace(/&width=\d+/, '') + '&width=200 200w, ' +
                        newSrc.replace(/&width=\d+/, '') + '&width=300 300w, ' +
                        newSrc.replace(/&width=\d+/, '') + '&width=400 400w, ' +
                        newSrc.replace(/&width=\d+/, '') + '&width=500 500w, ' +
                        newSrc.replace(/&width=\d+/, '') + '&width=600 600w';
      primaryImage.src = newSrc.replace(/&width=\d+/, '&width=600');
      primaryImage.srcset = newSrcset;
    }
  }
  
  function formatMoney(cents) {
    const price = (cents / 100).toFixed(2);
    return price + ' ₪';
  }
  
  function updatePrice(variant) {
    const priceList = card.querySelector('price-list');
    if (!priceList || !variant) return;
    
    const salePrice = priceList.querySelector('sale-price');
    const comparePrice = priceList.querySelector('compare-at-price');
    
    if (salePrice) {
      const srOnly = salePrice.querySelector('.sr-only');
      const srText = srOnly ? srOnly.outerHTML : '';
      salePrice.innerHTML = srText + formatMoney(variant.price);
    }
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (comparePrice) {
        const srOnly = comparePrice.querySelector('.sr-only');
        const srText = srOnly ? srOnly.outerHTML : '';
        comparePrice.innerHTML = srText + formatMoney(variant.compare_at_price);
        comparePrice.style.display = '';
      }
    } else if (comparePrice) {
      comparePrice.style.display = 'none';
    }
  }
  
  function updateVariant() {
    const { options, selectedCount } = getSelectedOptions();
    
    if (selectedCount < totalOptionGroups) {
      variantInput.value = '';
      if (button) {
        button.disabled = true;
        button.classList.add('is-disabled');
        button.classList.remove('is-unavailable');
      }
      return;
    }
    
    const variant = findVariant(options);
    
    if (variant) {
      variantInput.value = variant.id;
      updateImage(variant);
      updatePrice(variant);
      
      // Update SKU display if exists
      const skuEl = card.querySelector('.product-card__sku');
      if (skuEl && variant.sku) {
        skuEl.textContent = variant.sku;
      }
      
      if (button) {
        button.disabled = !variant.available;
        button.classList.remove('is-disabled');
        button.classList.toggle('is-unavailable', !variant.available);
      }
    } else {
      variantInput.value = '';
      if (button) {
        button.disabled = true;
        button.classList.add('is-unavailable');
      }
    }
  }
  
  swatches.forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      const container = this.closest('.product-card__color-swatches');
      container.querySelectorAll('.product-card__swatch').forEach(function(s) {
        s.classList.remove('is-selected');
      });
      this.classList.add('is-selected');
      updateVariant();
    });
  });
  
  selects.forEach(function(select) {
    select.addEventListener('change', updateVariant);
  });
}
